import $ from 'jquery'
import { Collapse, Dropdown, Modal, Tab, Tooltip } from 'bootstrap'

const ATTRIBUTE_PAIRS = [
    ['data-bs-toggle', 'data-toggle'],
    ['data-bs-target', 'data-target'],
    ['data-bs-dismiss', 'data-dismiss'],
    ['data-bs-parent', 'data-parent'],
]

function syncAttributePair(root, primaryAttr, legacyAttr) {
    root.querySelectorAll(`[${primaryAttr}], [${legacyAttr}]`).forEach((element) => {
        if (element.hasAttribute(primaryAttr) && !element.hasAttribute(legacyAttr)) {
            element.setAttribute(legacyAttr, element.getAttribute(primaryAttr))
        }

        if (element.hasAttribute(legacyAttr) && !element.hasAttribute(primaryAttr)) {
            element.setAttribute(primaryAttr, element.getAttribute(legacyAttr))
        }
    })
}

function resolveElement(target) {
    if (target && target.jquery) {
        return target.get(0)
    }

    return typeof target === 'string' ? document.querySelector(target) : target
}

function registerJqueryPlugin(name, ComponentClass) {
    $.fn[name] = function (config, ...args) {
        return this.each(function () {
            const options = typeof config === 'object' ? config : {}
            const instance = ComponentClass.getOrCreateInstance(this, options)

            if (typeof config === 'string' && typeof instance[config] === 'function') {
                instance[config](...args)
            }
        })
    }
}

export function normalizeBootstrapDataAttributes(root = document) {
    ATTRIBUTE_PAIRS.forEach(([primaryAttr, legacyAttr]) => {
        syncAttributePair(root, primaryAttr, legacyAttr)
    })
}

export function initTooltips(root = document) {
    root.querySelectorAll('[data-toggle="tooltip"], [data-bs-toggle="tooltip"]').forEach((element) => {
        Tooltip.getOrCreateInstance(element)
    })
}

export function showModal(target, options = {}) {
    const element = resolveElement(target)

    if (!element) {
        return null
    }

    const modal = Modal.getOrCreateInstance(element, options)
    modal.show()

    return modal
}

export function hideModal(target) {
    const element = resolveElement(target)

    if (!element) {
        return null
    }

    const modal = Modal.getOrCreateInstance(element)
    modal.hide()

    return modal
}

export function onModalShown(target, handler) {
    const element = resolveElement(target)

    if (element) {
        element.addEventListener('shown.bs.modal', handler)
    }

    return element
}

export function onModalHidden(target, handler) {
    const element = resolveElement(target)

    if (element) {
        element.addEventListener('hidden.bs.modal', handler)
    }

    return element
}

registerJqueryPlugin('modal', Modal)
registerJqueryPlugin('tooltip', Tooltip)
registerJqueryPlugin('dropdown', Dropdown)
registerJqueryPlugin('collapse', Collapse)
registerJqueryPlugin('tab', Tab)

$(function () {
    normalizeBootstrapDataAttributes()
    initTooltips()
})

$(document).ajaxComplete(() => {
    normalizeBootstrapDataAttributes()
    initTooltips()
})
